import { isInternalTraffic } from "@/helpers/helpers";

// Google Analytics gtag 類型定義
interface GtagFunction {
  (command: "event", eventName: string, eventParams?: Record<string, unknown>): void;
  (command: "js", date: Date): void;
  (
    command: "consent",
    action: "default" | "update",
    params?: { analytics_storage?: "granted" | "denied" },
  ): void;
}

interface GtagWindow extends Window {
  dataLayer?: unknown[];
  gtag?: GtagFunction;
}

declare const window: GtagWindow;

const ga = {
  /**
   * 追蹤自訂事件
   * @param name 事件名稱
   * @param params 事件參數（option）
   */
  trackEvent: (name: string, params?: Record<string, unknown>): void => {
    const gtag = window.gtag;
    if (!gtag || isInternalTraffic()) return;

    gtag("event", name, params);
  },

  /**
   * 檢查 Google Analytics 是否已初始化
   */
  isReady: (): boolean => {
    return typeof window.gtag === "function";
  },

  /**
   * 根據內部流量狀態更新 GA consent
   * 內部流量時設定為 denied，避免自動事件被送出
   */
  updateConsentForInternalTraffic: (): void => {
    const isInternal = isInternalTraffic();
    const gtag = window.gtag;
    if (!gtag) return;
    gtag("consent", "update", {
      analytics_storage: isInternal ? "denied" : "granted",
    });
  },
};

export default ga;
